import { useTooltip } from '@afterpaytouch/core'
import React, { RefObject, useEffect, useRef, useState } from 'react'
import { TooltipContent } from './TooltipContent'
import { ApplePayTooltip } from './ApplePayTooltip'

export const useApplePayTooltip = (
  verticalOffset = 0
): {
  tooltipTriggerRef: RefObject<HTMLDivElement>
  openTooltip: () => void
} => {
  const tooltipTriggerRef = useRef<HTMLDivElement>(null)
  const { showTooltip, unload } = useTooltip(tooltipTriggerRef, { closeOnOutsideClick: true, verticalOffset, matchTriggerWidth: true })
  useEffect(() => {
    return () => {
      unload()
    }
  }, [])

  const openTooltip = (): void => {
    showTooltip(<TooltipContent />)
  }

  return {
    tooltipTriggerRef,
    openTooltip,
  }
}

export const useApplePayTooltipClassic = (): {
  toggleTooltipClassic: () => void
  applePayTooltipRendererClassic: () => JSX.Element
  closeTooltip: () => void
} => {
  const id = 'apple-pay-learn-more-tooltip'
  const [tooltipShow, setTooltipShow] = useState(false)
  const closeTooltip = (): void => {
    setTooltipShow(false)
  }

  const toggleTooltipClassic = (): void => {
    setTooltipShow((tooltipShow) => !tooltipShow)
  }

  const applePayTooltipRendererClassic = (): JSX.Element => {
    return <ApplePayTooltip tooltipShow={tooltipShow} id={id} closeTooltip={closeTooltip} />
  }

  return { toggleTooltipClassic, applePayTooltipRendererClassic, closeTooltip }
}
